module.exports = __webpack_public_path__ + "static/media/lock-icon.3bb52c74.svg";